import moment, { Moment } from "moment";

export enum UnderScoreColor {
  Blue = "blue",
  Primary = "primary",
  DashedGreen = "dashed-green"
}

export type AvailabilityCalendarEvent = {
  start: Date;
  end: Date;
  color: UnderScoreColor;
};

interface WeekInfo {
  weekNum: number;
  weekDate: moment.Moment;
  year: number;
  yearName: string;
  monthName: string;
}

export function generateWeeks(startDate: Date, totalMonths: number = 12): WeekInfo[] {
  const start = moment(startDate);
  const end = moment(startDate).add(totalMonths, "months");
  const weeks: WeekInfo[] = [];

  const current = start.clone().startOf("isoWeek");

  while (current.isBefore(end)) {
    const endOfWeek = current.clone().endOf("isoWeek");

    const week = {
      weekNum: current.isoWeek(),
      weekDate: current.clone(),
      year: current.isoWeekYear(),
      yearName: current.format("GGGG"),
      monthName: endOfWeek.format("MMM")
    };
    weeks.push(week);
    current.add(1, "week");
  }

  return weeks;
}

export function getCellCalendarEvents(
  allEvents: AvailabilityCalendarEvent[],
  week: Date
): AvailabilityCalendarEvent[] {
  return allEvents.filter((x) => {
    const start = moment(x.start).startOf("isoWeek");
    const end = moment(x.end).endOf("isoWeek");

    return moment(week).isBetween(start, end, undefined, "[]");
  });
}

export function isBetween(date: Moment, start: Moment | null, end: Moment | null) {
  if (!start || !end) {
    return false;
  }

  return date.isBetween(start, end) || date.isBetween(end, start);
}

export function isSelected(date: Moment, start: Moment | null, end: Moment | null) {
  if (!start || !end) {
    return false;
  }

  return date.isSame(start, "isoWeek") || date.isSame(end, "isoWeek");
}
